import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="rounded-lg border border-background-200 bg-background-50 px-6 py-16 md:py-24 text-center relative overflow-hidden">
        <span className="absolute inset-x-0 top-1/2 -translate-y-1/2 text-[7rem] md:text-[12rem] font-black text-background-100 select-none pointer-events-none">
          404
        </span>
        <div className="relative z-10">
          <span className="w-16 h-16 mx-auto rounded-full bg-background-100 flex items-center justify-center text-foreground-400">
            <i className="ri-error-warning-line text-3xl" />
          </span>
          <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
            页面不存在
          </h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-3 text-sm text-foreground-500">
            你访问的页面可能已被移除或链接有误，返回首页继续浏览黄金投资软件吧。
          </p>
          <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-secondary-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors flex items-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-line text-base" />
              </span>
              返回首页
            </Link>
            <Link
              to="/softwares"
              className="h-10 px-5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 transition-colors flex items-center gap-2"
            >
              浏览全部软件
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}